import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import UtilPermission from '../utils/UtilPermission';

const usePermission = () => {
  const currentUser = useSelector((state) => state.currentUser);

  const polValues = useMemo(
    () => UtilPermission.getPolValues(currentUser),
    [currentUser]
  );

  const isSuperAdmin = UtilPermission.isSuperAdmin(currentUser);

  const can = useCallback(
    (name) => UtilPermission.hasPermission(name, currentUser),
    [currentUser]
  );

  return { can, polValues, isSuperAdmin };
};

export default usePermission;
